// src/services/notificationPreferences.ts
// Preferenze per-utente per-canale per-signal (Fase 6).
import api from '../api/axios';

export type NotificationChannel = 'webpush' | 'email' | 'telegram' | 'inapp';

export interface ChannelPreference {
  id?: number;
  channel: NotificationChannel;
  signal_function_name: string;
  enabled: boolean;
}

export async function listPreferences(): Promise<ChannelPreference[]> {
  const res = await api.get('api/notifications/preferences/');
  return Array.isArray(res.data) ? res.data : [];
}

/**
 * Aggiornamento bulk. Il backend fa update_or_create per ogni item.
 * Le righe non incluse nel payload restano invariate.
 */
export async function updatePreferencesBulk(
  items: ChannelPreference[],
): Promise<ChannelPreference[]> {
  const res = await api.patch('api/notifications/preferences/', items);
  return Array.isArray(res.data) ? res.data : [];
}
